import ConfigNode from 'Model/ConfigNode'
import ConfigQuery from 'Model/ConfigQuery'

class MergeRequest extends ConfigNode
  @className = 'MergeRequest'

  constructor: (id) ->
    super(id)

  @load: (id) ->
    super(id, @)

  @getByStatus: (status, limit = 1000, skip = 0) ->
    new ConfigQuery()
      .type(@)
      .limit(limit)
      .skip(skip)
      .equalTo('status', status)
      .find(@)

  @getOpen: (limit = 1000, skip = 0) ->
    @getByStatus('open', limit, skip)

  @getMerged: (limit = 1000, skip = 0) ->
    @getByStatus('merged', limit, skip)

  @getClosed: (limit = 1000, skip = 0) ->
    @getByStatus('closed', limit, skip)

  setSource: (source) ->
    @set('source', source)

  setTarget: (target) ->
    @set('target', target)

  setCreator: (creator) ->
    @set('creator', creator)

  setTitle: (title) ->
    @set('title', title)

  setDescription: (description) ->
    @set('description', description)

  setStatus: (status) ->
    @set('status', status)

export default MergeRequest
